import { useEffect, useState } from "react";
import styles from './Blog.module.css';

const API_BASE = `${window.location.origin}/wp-json/wp/v2`;
export default function BlogSection({title, text, sectionRef}) {
    const [blogData, setBlogData] = useState([]);

    useEffect(() => {
        fetch(`${API_BASE}/posts`)
        .then(res => res.json())
        .then(json => setBlogData(json))
        .catch(err => console.error(err));
    }, []);

    const mainBlog = blogData.filter(b=> b.acf?.is_home === true).slice(0, 3);
    return (
      <section className={styles['blog-section']} ref={sectionRef}>
        <div className="container-lg">
          <div className="row">
            <div className="col-12 col-lg-10 mx-auto">
              <div className={styles['blog-section_head']}>
                <h2  className={styles['blog-section_title']}>{title}</h2>
                <p className={styles['blog-section_text']}>{text}</p>
              </div>
            
              <div className="row position-relative blog-row">
                {mainBlog.length > 0 && mainBlog.map(item => 
                  <div className="col-11 col-sm-9 col-lg-4" key={item.id}>
                      <div className={`${styles['blog-card']} position-relative `}>
                          <figure className={styles['blog-card_media']}>
                              <a href={item.link}  className="ratio ratio-16x9">
                                <img src={item.featured_image_url} width="320" height="192" alt={item.title.rendered} />
                              </a>
                          </figure>
                          <div className={styles['blog-card_content']}>
                            <h3 className={styles['blog-card_title']}><a className={styles['blog-card_link']} href={item.link}>{item.title.rendered}</a></h3>
                          </div>
                      </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}